import {PlateRecognitionActionTypes} from '../../constants/actionType';

export const setIsPlateRecognitionEnabled = (isPlateRecognitionEnabled) => ({
  type: PlateRecognitionActionTypes.SET_IS_PLATE_RECOGNITION_ENABLED,
  isPlateRecognitionEnabled,
});

export const setIsAlreadyScannedAllEmptyNests = (isAlreadyScannedAllEmptyNests) => ({
  type: PlateRecognitionActionTypes.SET_IS_ALREADY_SCANNED_ALL_EMPTY_NESTS,
  isAlreadyScannedAllEmptyNests,
});

export const setAllPlatesScanned = (isAllPlatesScanned) => ({
  type: PlateRecognitionActionTypes.SET_IS_ALL_PLATES_SCANNED,
  isAllPlatesScanned,
});

export const setIsPlateAlreadyTrained = (isPlateAlreadyTrained) => ({
  type: PlateRecognitionActionTypes.SET_IS_ALL_PLATE_ALREADY_TRAINED,
  isPlateAlreadyTrained,
});

export const setIsPlateEditStateChanged = (isPlateEditStateChanged) => ({
  type: PlateRecognitionActionTypes.SET_IS_PLATE_EDIT_STATE_CHANGED,
  isPlateEditStateChanged,
});

export const setIsIncompatibleVisionVersion = (isIncompatibleVisionVersion) => ({
  type: PlateRecognitionActionTypes.SET_IS_INCOMPATIBLE_VISION_VERSION,
  isIncompatibleVisionVersion,
});

export const restorePlateRecognitionState = (state) => ({
  type: PlateRecognitionActionTypes.RESTORE_PLATE_RECOGNITION_STATE,
  state,
});
